<template>
	<div style="width: 100%">
		<div
			class="agenda-card-wrapper d-flex justify-space-between align-center pb-3"
			:style="wrapperStyle"
		>
			<div style="width: 100%">
				<SponsorBadge
					v-if="sponsoredLabel"
					:text="sponsoredLabel"
					:top="'0px'"
					:right="'0px'"
					:icon="'star'"
					:iconSize="10"
					:iconColor="'#ffffff'"
				/>
				<div
					v-if="timeStatus"
					class="agenda-card-wrapper__time-start"
					:style="{
						backgroundColor:
							timeStatus === 'now'
								? 'var(--username-category-title)'
								: 'var(--badge-pin-background)',
					}"
				>
					{{ timeStatus === 'now' ? 'Now' : 'Soon' }}
				</div>
				<div class="d-flex align-center justify-space-between">
					<div
						:style="{ width: '100%' }"
						@click="toggleToSession"
						class="d-flex px-3 align-start u-cursor-pointer"
					>
						<div
							class="agenda-card-date"
							v-bind:style="{
								color: isAgendaPast ? '#AAA' : 'var(--username-category-title)',
							}"
						>
							<div class="agenda-card-date__begin">
								{{
									formatTime(
										agendaEvent.events_agenda_from,
										agendaEvent.agendaTimezone
									)
								}}
							</div>
							<div class="agenda-card-date__end">
								{{
									formatTime(
										agendaEvent.events_agenda_to,
										agendaEvent.agendaTimezone
									)
								}}
							</div>
							<div class="agenda-card-date__end">
								({{ getTimezoneAbbreviation(agendaEvent.agendaTimezone) }})
							</div>
							<div
								v-if="agendaEvent && agendaEvent.tracks"
								class="agenda-card-date__circle-wrapper"
							>
								<div
									v-for="i in agendaEvent.tracks"
									:key="i.track_id"
									class="agenda-card-date__circle"
									:style="{ background: isAgendaPast ? '#AAA' : i.track_color }"
								/>
							</div>
						</div>
						<div class="ml-2">
							<div
								class="agenda-card-title"
								v-bind:style="{
									color: isAgendaPast ? '#AAA' : 'var(--accent-color)',
								}"
							>
								{{ agendaEvent.events_agenda_title }}
								<div
									class="agenda-card-description mb-0"
									v-bind:style="{
										color: isAgendaPast
											? '#AAA'
											: 'var(--username-category-title)',
									}"
								>
									{{ agendaEvent.events_agenda_text }}
								</div>
							</div>
							<div
								class="agenda-card-location mt-2"
								v-if="agendaEvent && agendaEvent.session_location"
								v-bind:style="{
									color: isAgendaPast ? '#AAA' : 'var(--location-color)',
								}"
							>
								<Icon
									type="pin"
									:color="isAgendaPast ? '#aaa' : 'var(--location-color)'"
									:size="12"
									:pr="4"
								/>
								{{ agendaEvent.session_location }}
							</div>
							<div
								v-if="agendaEvent && agendaEvent.session_limited && !isAgendaPast"
								class="agenda-card-seats"
							>
								Limited seats
							</div>
						</div>
					</div>
					<div
						class="agenda-card-wrapper__register u-cursor-pointer pr-3"
						@click.prevent="toggleMyAgenda"
					>
						<Icon
							v-if="agendaEvent.session_type === 2"
							type="my_session"
							color="#9B9B9B"
							:size="24"
						/>
						<Icon
							v-else
							:type="scheduleIcon.icon"
							:color="scheduleIcon.color"
							:size="24"
						/>
					</div>
				</div>
				<div
					:style="{ color: isAgendaPast ? '#AAA' : 'var(--text_button_tint)' }"
					v-if="agendaEvent && agendaEvent.subSessionsCount > 0"
					@click="toggleToSubSessionList"
					class="agenda-card-wrapper__sub-session u-cursor-pointer mt-3 pt-3 pl-3"
				>
					View Sub-Session(s)
				</div>
				<div
					v-if="parentSessionText"
					:style="{ color: isAgendaPast ? '#AAA' : 'var(--text_button_tint' }"
					@click="toggleParentSession"
					class="agenda-card-wrapper__sub-session u-cursor-pointer mt-3 pt-3 pl-3"
				>
					Sub-session of: {{ parentSessionText }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { mapActions, mapGetters } from 'vuex'
import SponsorBadge from '@/components/SponsorBadge.vue'
import Dwh from '@/mixins/Dwh'

Vue.use(VueScrollTo)

export default {
	name: 'AgendaCard',
	components: {
		SponsorBadge,
	},
	mixins: [Dwh],
	props: {
		agendaEvent: {
			type: Object,
			default: () => ({}),
		},
		selectedButton: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			isTimeStarted: false,
			isSchedule: null,
		}
	},
	methods: {
		...mapActions('event', ['addMyAgenda', 'removeMyAgenda']),
		toggleToSubSessionList() {
			this.$router.push({
				name: 'sub-session-list',
				query: {
					events_agenda_id: this.agendaEvent.events_agenda_id,
					event_id: this.$route.params.id || this.$route.query.event_id,
				},
			})
		},
		handleToSession() {
			this.sendTrigger({
				category: 'Agenda',
				action: 'click_session_agenda',
				module: 'Events',
				title: 'Agenda',
				id2: this.$route.params.id,
			})
		},
		toggleToSession() {
			this.handleToSession()
			this.$router.push({
				name: 'event-session-by-id',
				params: {
					id: this.agendaEvent.events_agenda_id,
				},
				query: {
					event_id: this.$route.params.id || this.$route.query.event_id,
				},
			})
		},
		toggleParentSession() {
			this.$router.push({
				name: 'event-session-by-id',
				params: {
					id: this.agendaEvent?.parentSession?.events_agenda_id,
				},
				query: {
					event_id: this.$route.query.event_id,
				},
			})
		},
		formatTime(timestamp, timezone) {
			const options = {
				hour: '2-digit',
				minute: '2-digit',
				hour12: true,
				timeZone: 'UTC',
			}

			const date = new Date(timestamp * 1000)
			const offset = Number(timezone.timezone_utc.slice(-2))
			const sign = timezone.timezone_utc.slice(3, 4)

			if (sign === '-') {
				date.setHours(date.getHours() - offset)
			} else {
				date.setHours(date.getHours() + offset)
			}

			return date.toLocaleTimeString('en-US', options)
		},

		getTimezoneAbbreviation(timezone) {
			return timezone.timezone_code || 'UTC'
		},
		handleAddSession() {
			this.sendTrigger({
				category: 'Agenda',
				action: 'click_add_session_agenda',
				module: 'Events',
				title: 'Agenda',
				id2: this.$route.params.id,
			})
		},
		handleRemoveSession() {
			this.sendTrigger({
				category: 'Agenda',
				action: 'click_remove_session_agenda',
				module: 'Events',
				title: 'Agenda',
				id2: this.$route.params.id,
			})
		},
		async toggleMyAgenda() {
			if (this.isMyAgendaLoading || this.agendaEvent.session_type === 2) return
			const prev = this.isSchedule
			this.isSchedule = !prev
			try {
				if (prev) {
					this.handleRemoveSession()
					await this.removeMyAgenda({
						id: this.agendaEvent.events_agenda_id,
						myAgenda: this.$route.name === 'my-agenda-events',
						single: false,
						filter: this.currentFilter,
					})
				} else {
					this.handleAddSession()
					await this.addMyAgenda({
						id: this.agendaEvent.events_agenda_id,
						single: false,
					})
				}
			} catch (e) {
				console.error('Agenda update failed', e)
				this.isSchedule = prev
			}
		},
	},
	watch: {
		agendaEvent: {
			handler() {
				this.isSchedule = this.agendaEvent.is_scheduled
			},
			immediate: true,
		},
	},
	computed: {
		...mapGetters('event', ['isMyAgendaLoading', 'myAgendaIdIsLoading']),
		...mapGetters('settings', ['styles']),
		parentSessionText() {
			return this.agendaEvent?.parentSession?.events_agenda_text || ''
		},
		wrapperStyle() {
			return {
				paddingTop: this.agendaEvent.sponsored_by || this.timeStatus ? '32px' : '12px',
				borderColor: this.timeStatus ? 'var(--vote_bar_tint)' : '#e2e2e2',
			}
		},
		timeStatus() {
			const now = new Date()
			const from = new Date(this.agendaEvent.events_agenda_from * 1000)
			const to = new Date(this.agendaEvent.events_agenda_to * 1000)
			const fifteenMinutesInMs = 15 * 60 * 1000

			if (now >= from && now <= to) {
				return 'now'
			} else if (now >= new Date(from.getTime() - fifteenMinutesInMs) && now < from) {
				return 'soon'
			}
			return ''
		},

		sponsoredLabel() {
			return this.agendaEvent.sponsored_by ? this.agendaEvent.sponsored_by : ''
		},
		scheduleIcon() {
			return this.isSchedule
				? {
						icon: 'remove_schedule',
						color: '#9B9B9B',
				  }
				: {
						icon: 'add_schedule',
						color: this.isAgendaPast ? '#9B9B9B' : 'var(--button-icon-tint)',
				  }
		},
		isAgendaPast() {
			return !this.timeStatus && Date.now() > this.agendaEvent.events_agenda_to * 1000
		},
		currentFilter() {
			const registeredFilter = this.selectedButton.some((button) => button === 'registered')
			const scheduledFilter = this.selectedButton.some((button) => button === 'scheduled')
			return (registeredFilter && scheduledFilter) || (!registeredFilter && !scheduledFilter)
				? 'schedregist'
				: registeredFilter
				? 'registered'
				: 'scheduled'
		},
	},
}
</script>

<style lang="scss">
.agenda-card {
	&-wrapper {
		background: #ffffff;
		border-radius: 8px;
		position: relative;
		margin-bottom: 8px;
		border: 1px solid #e2e2e2;
		&__sub-session {
			border-top: 1px solid #e2e2e2;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: #0055a3;
		}
		&__register {
			width: 30px;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		&__time-start {
			position: absolute;
			top: 0;
			left: 0;
			width: 52px;
			height: 20px;
			background-color: #0055a3;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 12px;
			line-height: 16px;
			letter-spacing: 0;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 6px 0 0 0;
			clip-path: polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 8px) 100%, 0 100%);
		}
	}
	&-seats {
		width: 100px;
		height: 24px;
		background-color: var(--badge-pin-background) !important;
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 140%;
		letter-spacing: 0;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 20px;
		margin-top: 8px;
	}

	&-date {
		color: var(--accent-color);
		font-size: 13px;
		flex-shrink: 0;
		min-width: 52px;
		&__begin {
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 13px;
			line-height: 140%;
			letter-spacing: 0;
		}

		&__end {
			font-family: Inter, sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 140%;
			letter-spacing: 0;
		}
		&__circle {
			margin-top: 8px;
			width: 6px;
			height: 6px;
			background-color: #674ea6;
			gap: 6px;
			border-radius: 50%;
		}
		&__circle-wrapper {
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
			max-width: calc((6px * 5) + (4px * 4));
		}
	}

	&-description {
		color: var(--username-category-title);
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 140%;
		letter-spacing: 0;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		white-space: normal;
	}

	&-tag {
		display: flex;
		align-items: center;
		font-size: 13px;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		line-height: 19.37px;

		p {
			word-break: break-all;
		}
	}

	&-location {
		display: flex;
		font-family: 'Inter', sans-serif;
		font-weight: 500;
		font-size: 13px;
		line-height: 140%;
		letter-spacing: 0;
	}

	&-schedule {
		&-btn {
			background-color: transparent !important;
			padding: 0 !important;
			min-width: auto !important;
		}
	}
}
</style>
